import Axios from "@/plugins/Axios";

export class HorariosService {
  async syncAll() {
    const response = await Axios().get(`listar-horarios`);
    return response.data;
  }
}
export default new HorariosService();
